import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (year) => {
	return fetch(
		Methods.GET,
		EndPoints.FINANCIAL_STATEMENT_INFO.replace(':year', year),
		null,
		null,
		true
	);
};
